module.exports = __webpack_public_path__ + "img/gquest.609350a1.png";